import { CameraPickButton, WithCameraClear } from "@/components/cameras/camera-pick-controls"
import { CameraPickerDialog, type CameraPickerPreset } from "@/components/cameras/camera-picker-dialog"
import { useTranslation } from "@/hooks/use-translation"

type Props = {
  projectId: number
  label: string
  presets: CameraPickerPreset[]
  selectedIds: number[]
  onSelectedIdsChange: (ids: number[]) => void
  open: boolean
  onOpenChange: (open: boolean) => void
  onPresetsLoaded: (presets: CameraPickerPreset[]) => void
}

/** Выбор камеры шота в тулбаре видео-промпта: кнопка со сбросом и диалог пресетов. */
export function ShotCameraSelect({
  projectId,
  label,
  presets,
  selectedIds,
  onSelectedIdsChange,
  open,
  onOpenChange,
  onPresetsLoaded,
}: Props) {
  const { t } = useTranslation("shot")
  return (
    <div className="ml-auto flex shrink-0 items-center gap-1">
      <WithCameraClear
        showClear={selectedIds.length > 0}
        clearTitle={t("common.clearCamera")}
        onClear={() => onSelectedIdsChange([])}
      >
        <CameraPickButton
          label={label}
          title={t("common.pickCamera")}
          reserveClearSpace={selectedIds.length > 0}
          onClick={() => onOpenChange(true)}
        />
      </WithCameraClear>
      <CameraPickerDialog
        open={open}
        onOpenChange={onOpenChange}
        projectId={projectId}
        presets={presets}
        selectedId={selectedIds[0] ?? null}
        onSelect={(preset) => onSelectedIdsChange([preset.id])}
        onPresetsLoaded={onPresetsLoaded}
        nested
      />
    </div>
  )
}
